"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MenuSingleLayer = _interopRequireDefault(require("./MenuSingleLayer"));
var _MenuDoubleLayer = _interopRequireDefault(require("./MenuDoubleLayer"));
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Layout',
  components: {
    MenuSingleLayer: _MenuSingleLayer.default,
    MenuDoubleLayer: _MenuDoubleLayer.default
  },
  data: function data() {
    return {};
  },
  methods: {}
};